import type { FieldErrors, FieldValues } from 'react-hook-form';

export const getErrorMessage = <T extends FieldValues>(errors: FieldErrors<T> = {}, name: string) => {
  const keys = name?.split('.');
  const hasNestedKey = keys?.length > 1;

  if (hasNestedKey) {
    let currentErrors: FieldErrors<T> | undefined = errors;

    for (let i = 0; i < keys.length - 1; i++) {
      const key = keys[i] as keyof typeof currentErrors;
      currentErrors = currentErrors?.[key] as FieldErrors<T> | undefined;
      if (!currentErrors) return '';
    }

    const lastKey = keys[keys.length - 1] as keyof typeof currentErrors;
    return typeof currentErrors?.[lastKey]?.message === 'string' ? currentErrors[lastKey].message : '';
  }

  return typeof errors?.[name]?.message === 'string' ? errors[name].message : '';
};
